import React from "react"
import PropTypes from 'prop-types'
import { graphql, useStaticQuery } from 'gatsby'
import { getOfficesByMarket } from '../../helper'
import GlobeWrap from './globeWrap'

import Large1 from '../../images/blobs/large1.inline.svg'
import * as style from './globe.module.scss'

const Globe = ({ title, fullDisplay }) => {
  const data = useStaticQuery(graphql`{
  allWpOffice(sort: {fields: date, order: ASC}) {
    nodes {
      title
      slug
      link
      OfficeData {
        jobLink {
          url
          email
        }
        market {
          name
        }
      }
      OfficeAddress {
        address {
          title
          address1
          address2
          address3
          phoneNumber
          location {
            latitude
            longitude
          }
        }
      }
      Header {
        headerImage {
          altText
          title
          localFile {
            childImageSharp {
              gatsbyImageData(width: 640, layout: CONSTRAINED)
            }
          }
        }
      }
    }
  }
}
`)
  const offices = data.allWpOffice.nodes
  const officesByMarket = getOfficesByMarket(offices)
  const props = {
    title, offices, officesByMarket, fullDisplay
  }

  return (
    <section className={style.globe}>
      {!fullDisplay && (
        <Large1 className={style.largeBlob} />
      )}
      <GlobeWrap {...props} />
    </section>
  )
}

Globe.defaultProps = {
  fullDisplay: false
}
Globe.propTypes = {
  title: PropTypes.string.isRequired,
  fullDisplay: PropTypes.bool
}

export default Globe
